import React from 'react';
import styles from "./styles.module.scss";
import { ChartBottomMapped } from './types';

interface ChartDetailsProps {
  data: ChartBottomMapped[];
}

const ChartDetails = ({ data = [] }: ChartDetailsProps) => {
  return (
    <div className={styles.details_container}>
      {data.map((d, index) => (
        <div className={styles.item} key={index}>
          <div className={styles.title}>{d.title}</div>
          <div className={styles.subtitle}>{d.subTitle}</div>
        </div>
      ))}
    </div>
  );
};

export default ChartDetails;
